import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { IPageResult } from '../interfaces/page-result';
import { BaseDataService } from './base.data.service';
import { HttpResponsesHandlersFactory } from '../handlers/http-responses-handler';
import { Observable } from 'rxjs';

export abstract class ReadService<TEntity, TFilter> extends BaseDataService {
  protected abstract url: string;
  protected abstract entityTitle: string;

  constructor(http: HttpClient, handlersFactory: HttpResponsesHandlersFactory) {
    super(http, handlersFactory);
  }

  //Get element by Id
  get(id: number | string): Promise<TEntity> {
    return this.handleRequest<TEntity>(
      this.http.get<TEntity>(`${this.url}/${id}`),
      this.handlersFactory.getForReadById(this.entityTitle),
    );
  }

  // Get element collection by filter
  // Filter this is
  //first - How many items should skip
  //rows - How many items are required to receive
  //sortOrder - sort order(-1 - Desc, 1 - Asc)
  //sortField - sort field
  //
  // Result
  //total - total count
  //items - element collection
  getPage(filterCommand: TFilter): Promise<IPageResult<TEntity>> {
    return this.handleRequest<IPageResult<TEntity>>(
      this.http.get<IPageResult<TEntity>>(this.url, {
        params: this.constructHttpParams(filterCommand),
      }),
      this.handlersFactory.getForReadByFilter(),
    );
  }

  getPageAsObservable(filterCommand: TFilter): Observable<IPageResult<TEntity>> {
    return this.http.get<IPageResult<TEntity>>(this.url, {
      params: this.constructHttpParams(filterCommand),
    });
  }

  public extractData(res: any) {
    return res;
  }

  public handleError(errorResponse: HttpErrorResponse | any) {
    let fullErrorMessage: string;
    if (errorResponse instanceof HttpErrorResponse) {
      const error = errorResponse.error || JSON.stringify(errorResponse);
      fullErrorMessage = `Error Status: ${errorResponse.status} - ${
        errorResponse.statusText || ''
      } ${error}`;
    } else {
      fullErrorMessage = errorResponse.message ? errorResponse.message : errorResponse.toString();
    }
    if (errorResponse.status === 401) {
      window.location.reload();
    }

    return Promise.reject(fullErrorMessage);
  }
}
